import { InsightsAnalysisType } from '@terminal/views/dashboard/my-assets-widget/assets-table/utils';

export const METHOD_SUB_CLS_GROUPING: Record<string, InsightsAnalysisType> = {
  EntryPoint: 'Technical',
  Valuations: 'Fundamental',
  Positioning: 'Technical',
  Momentum: 'Technical',
  LeadingIndicator: 'Fundamental',
  MarketData: 'Technical',
  VolumeAnalysis: 'Technical',
  EquityGrowthGauge: 'Fundamental',
  EquityConsensusTrend: 'Fundamental',
  EconomicGrowthGauge: 'Macroeconomics',
  EconomicInflationGauge: 'Macroeconomics',
  FinancialConditions: 'Macroeconomics',
  Volatility: 'Technical',
  PriceLevel: 'Technical',
  MainYield: 'Technical',
  GroupTechnicalAnalysis: 'Technical',
  Geopolitical: 'Macroeconomics',
  Sentiment: 'Technical',
  Seasonality: 'Technical',
  EquityYield: 'Fundamental',
  Event: 'Fundamental',
  TechAnalysis: 'Technical',
  OnChainMetrics: 'Fundamental',
  company: 'company',
};

export const EXPLORE_GROUPING: Record<string, InsightsAnalysisType> = {
  fundamentals: 'Fundamental',
  technicals: 'Technical',
  macroeconomics: 'Macroeconomics',
};
